let language = {
    STORE_PRODUCT_EMPTY_STORE_DES1:"Add your ",
    STORE_PRODUCT_EMPTY_STORE_GO_STORE:"store",
    STORE_PRODUCT_EMPTY_STORE_DES2:" to begin creating products. "

};

export { language }